import { useState } from "react";

function BmiCalc() {
  const [weight, setWeight] = useState("");
  const [height, setHeight] = useState("");
  const [bmi, setBmi] = useState(null);
  const [message, setMessage] = useState("");
  const [statusColor, setStatusColor] = useState("");

  const calcBmi = (e) => {
    e.preventDefault();
    const w = parseFloat(weight);
    const h = parseFloat(height);

    if (!w || !h || w <= 0 || h <= 0) {
      setMessage("Please enter valid positive numbers for height and weight.");
      setStatusColor("text-red-500");
      setBmi(null);
      return;
    }

    const heightInMeters = h / 100;
    const bmiValue = w / (heightInMeters * heightInMeters);
    const formattedBmi = bmiValue.toFixed(1);
    setBmi(formattedBmi);

    if (bmiValue < 18.5) {
      setMessage("Underweight");
      setStatusColor("text-yellow-400");
    } else if (bmiValue >= 18.5 && bmiValue < 24.9) {
      setMessage("Healthy Normal Weight");
      setStatusColor("text-green-400");
    } else if (bmiValue >= 25 && bmiValue < 29.9) {
      setMessage("Overweight");
      setStatusColor("text-orange-400");
    } else {
      setMessage("Obese");
      setStatusColor("text-red-500");
    }
  };

  return (
    <>
      <section className="bmi-section py-[60px] md:py-[80px] relative bg-black min-h-screen flex items-center">
        <div className="container page-padding relative z-10 w-full">
          <div className="text-white max-w-xl mx-auto lg:mx-0 bg-black/80 backdrop-blur-md p-6 sm:p-8 md:p-10 rounded-2xl border border-neutral-800 shadow-2xl">
            <h2 className="text-[28px] sm:text-[32px] md:text-[36px] font-bold leading-tight mb-3 md:mb-4">
              Calculate Your <span className="text-brand-gradient">BMI</span>
            </h2>
            <p className="text-[14px] sm:text-[15px] text-neutral-400 mb-6 md:mb-8 leading-relaxed">
              Body Mass Index (BMI) is a simple indicator of your weight relative to your height.
              Find out your range and let our certified coach tailor your transformation program!
            </p>
            <form onSubmit={calcBmi} className="flex flex-col gap-4 md:gap-6">
              <div className="flex flex-col sm:flex-row gap-4">
                <div className="w-full sm:w-1/2 flex flex-col gap-2">
                  <label className="text-[12px] sm:text-[13px] uppercase font-bold text-neutral-400">Weight (kg)</label>
                  <input
                    value={weight}
                    onChange={(e) => setWeight(e.target.value)}
                    className="w-full bg-neutral-900 text-white text-[14px] sm:text-[15px] border border-neutral-700 px-4 sm:px-5 py-3 rounded focus:border-[#ffd600] outline-none transition"
                    type="number"
                    step="any"
                    placeholder="e.g. 70"
                    required
                  />
                </div>
                <div className="w-full sm:w-1/2 flex flex-col gap-2">
                  <label className="text-[12px] sm:text-[13px] uppercase font-bold text-neutral-400">Height (cm)</label>
                  <input
                    value={height}
                    onChange={(e) => setHeight(e.target.value)}
                    className="w-full bg-neutral-900 text-white text-[14px] sm:text-[15px] border border-neutral-700 px-4 sm:px-5 py-3 rounded focus:border-[#ffd600] outline-none transition"
                    type="number"
                    step="any"
                    placeholder="e.g. 175"
                    required
                  />
                </div>
              </div>

              {bmi && (
                <div className="mt-2 md:mt-4 p-4 sm:p-6 bg-neutral-900/90 border border-neutral-800 rounded-xl flex flex-col sm:flex-row items-center justify-between gap-4 sm:gap-6">
                  <div className="text-center sm:text-left w-full sm:w-auto">
                    <span className="text-[11px] sm:text-[13px] text-neutral-400 uppercase font-semibold block">Your BMI Score</span>
                    <span className="text-[32px] sm:text-[36px] font-extrabold text-[#ffd600]">{bmi}</span>
                  </div>
                  <div className="text-center sm:text-right w-full sm:w-auto border-t sm:border-t-0 sm:border-l border-neutral-800 pt-4 sm:pt-0 sm:pl-6">
                    <span className="text-[11px] sm:text-[13px] text-neutral-400 uppercase font-semibold block">Status</span>
                    <span className={`text-[16px] sm:text-[18px] font-bold ${statusColor}`}>{message}</span>
                  </div>
                </div>
              )}

              <button
                type="submit"
                className="text-[13px] sm:text-[14px] uppercase font-bold tracking-wider mt-2 md:mt-4 bg-brand-gradient text-white py-3 sm:py-4 px-6 sm:px-8 hover-brand-gradient transition-all duration-300 rounded-lg shadow-lg w-full sm:w-auto"
              >
                Calculate BMI
              </button>
            </form>
          </div>
        </div>
      </section>
    </>
  );
}

export default BmiCalc;